<template>
  <md-list-item v-if="taurusUpdated.length > 0" class="change-taid" @click="isFormOpened = !isFormOpened">

    <span class="md-list-item-text">{{i18n.set_change_taid() }}</span>
    <md-icon class="md-icon--half-sized">keyboard_arrow_right</md-icon>

    <md-dialog class="change-taid"
               :md-active.sync="isFormOpened"
               :md-click-outside-to-close="!isPending">
      <md-progress-bar md-mode="indeterminate" v-if="isPending"/>
      <md-dialog-title>{{ i18n.set_change_taid() }}</md-dialog-title>

      <form novalidate
            class="change-taid"
            @submit.prevent="submit">

        <div class="app__dialog-inner">
          <div v-if="form.idx !== -1" class="label-select__actions">
            <label class="label-select__caption">{{ i18n.lbl_auto_withdraw() }}</label>
          </div>

          <template v-if="form.idx !== -1">
            <md-field>
              <md-select v-if="taurusUpdated.length > 1"
                         name="taid"
                         v-model="form.idx"
                         :label="i18n.lbl_taid()">
                <md-option v-for="(val, i) in taurusUpdated" :value="i" :selected="i === form.idx" :key="i">
                  {{val.id}}
                </md-option>
              </md-select>
              <div v-if="taurusUpdated.length === 1" class="change-taid__item">
                {{ taurusUpdated[0].id }}
              </div>
              <div v-if="form.idx !== -1" class="auto-withdraw" @click="onAutoWithdraw">
                <md-icon v-if="taurusUpdated[form.idx].auto"
                         class="select-icon-size flex-end__item md-primary">check_box</md-icon>
                <md-icon v-else
                         class="select-icon-size flex-end__item">crop_3_2</md-icon>
              </div>
            </md-field>
          </template>

        </div>

        <md-dialog-actions class="md-layout md-alignment-center-right">
          <template v-if="isUpdated">
            <md-button type="submit" class="md-primary" :disabled="isPending">{{ i18n.lbl_submit() }}</md-button>
          </template>

          <md-button type="button" class="md-primary" :disabled="isPending" @click="isFormOpened = !isFormOpened">{{ i18n.lbl_close() }}</md-button>
        </md-dialog-actions>
      </form>
    </md-dialog>
  </md-list-item>
</template>

<script>
  import { TheMask } from 'vue-the-mask'
  import { mapGetters, mapActions } from 'vuex'
  import { EventDispatcher } from '@js/events/event_dispatcher'
  import { vuexTypes } from '@vuex/types'
  import { i18n } from '@js/i18n'
  import Form from '@com/mixins/form.mixin'
  import { confirmAction } from '@js/modals/confirmation_message'

  export default {
    name: 'change-taid',
    components: { TheMask },
    mixins: [Form],
    data: _ => ({
      isFormOpened: false,
      isDisabled: false,
      isReadyToAdd: false,
      isUpdated: false,
      i18n,
      form: {
        idx: -1,
        newID: '',
        error: {show: false, message: ''}
      },
      taurusUpdated: []
    }),
    computed: {
      ...mapGetters([
        vuexTypes.userTaurus,
        vuexTypes.userUplataInsha
      ])
    },
    async created () {
      await this.updateObjects()
    },
    methods: {
      ...mapActions({
        updateTaurus: vuexTypes.SET_USER_TAURUS,
        deleteTaurus: vuexTypes.DELETE_USER_TAURUS,
        getTaurus: vuexTypes.GET_USER_TAURUS,
        updateUplataInsha: vuexTypes.SET_USER_UPLATA_INSHA,
        getUplataInsha: vuexTypes.GET_USER_UPLATA_INSHA
      }),
      async updateObjects (activeItem = 0) {
        await this.getTaurus()
        this.taurusUpdated = []
        for (const i in this.userTaurus) {
          const item = this.userTaurus[i]
          this.taurusUpdated.push({id: item.id, auto: item.auto})
        }
        this.form.newID = ''
        this.isUpdated = false
        this.isReadyToAdd = false
        this.isDisabled = this.taurusUpdated.length === 0
        if (this.isDisabled) {
          this.form.idx = -1
          this.form.error = {show: true, message: i18n.lbl_add_taurus()}
        } else {
          this.form.idx = activeItem
          this.form.error = {show: false, message: ''}
        }
      },
      newTaidUpdated (id) {
        this.isReadyToAdd = false
        if (id.length === 0) {
          this.form.error = {show: false}
        } else if (id.length !== 7) {
          this.form.error = {show: true, message: i18n.lbl_invalid_taid_len()}
        } else if (this.taurusUpdated.filter(card => card.id === id).length) {
          this.form.error = {show: true, message: i18n.lbl_number_is_exists()}
        } else {
          this.form.error = {show: false, message: ''}
          this.isReadyToAdd = true
        }
      },
      newTaidLeave () {
        this.form.newID = ''
        this.form.idx = 0
      },
      async onAutoWithdraw () {
        // check autowithdraw is enabled on another Taurus cards
        if (!this.taurusUpdated[this.form.idx].auto) {
          let idx = -1
          for (let i = 0; i < this.taurusUpdated.length; i++) {
            if (i !== this.form.idx && (this.taurusUpdated[i].auto || this.userTaurus[i].auto)) {
              idx = i
              break
            }
          }
          console.log('taurus idx', idx)
          // check autowithdraw is enabled on another Uplata Insha cards
          if (idx === -1) {
            await this.getUplataInsha()
            console.log('this.userUplataInsha.length', this.userUplataInsha.length)
            for (let i = 0; i < this.userUplataInsha.length; i++) {
              console.log('check uplata', i, this.userUplataInsha[i].id, this.userUplataInsha[i].auto)
              if (this.userUplataInsha[i].auto) {
                const opts = {
                  message: i18n.set_confirm_autowithdraw_change({name: i18n.lbl_uplata_insha_name(), id: this.userUplataInsha[i].id})
                }
                if (!await confirmAction(opts)) return
                await this.unmarkUplataInsha(i)
                return
              }
            }
          } else {
            const opts = {
              message: i18n.set_confirm_autowithdraw_change({ name: 'UPLATA', id: this.taurusUpdated[idx].id })
            }
            if (!await confirmAction(opts)) return
            this.taurusUpdated[idx].auto = false
          }
        }
        this.taurusUpdated[this.form.idx].auto = !this.taurusUpdated[this.form.idx].auto

        let i = 0
        for (; i < this.taurusUpdated.length; i++) {
          const id = this.taurusUpdated[i].id
          const auto = this.taurusUpdated[i].auto
          if (this.userTaurus.filter(card =>
            card.id === id && card.auto === auto).length === 0) break
        }
        this.isUpdated = i < this.taurusUpdated.length
      },
      async unmarkUplataInsha (idx) {
        this.disable()
        try {
          this.userUplataInsha[idx].auto = false
          await this.updateUplataInsha(this.userUplataInsha)
          this.taurusUpdated[this.form.idx].auto = true
          await this.updateTaurus(this.taurusUpdated)
          this.isUpdated = false
          this.updateObjects(this.form.idx)
          EventDispatcher.dispatchShowSuccessEvent(i18n.set_cards_changed())
        } catch (error) {
          const err = (await error).message
          console.error(err)
          if (error.showBanner) {
            error.showBanner(i18n.unexpected_error())
          } else {
            EventDispatcher.dispatchShowErrorEvent(i18n.unexpected_error() + ': ' + err)
          }
          this.taurusUpdated[this.form.idx].auto = false
        }
        this.enable()
      },
      async onDelete () {
        const taurus = this.taurusUpdated[this.form.idx]
        const opts = {
          title: i18n.lbl_delete_confirm_title(),
          message: i18n.lbl_id_delete_confirm(taurus),
          confirmText: i18n.lbl_delete()
        }
        if (!await confirmAction(opts)) return

        this.disable()
        if (await this.deleteTaurus(taurus)
          .then(_ => {
            return true
          }).catch(error => {
            console.error(error)
            if (error.showBanner) {
              error.showBanner(i18n.unexpected_error())
            } else {
              EventDispatcher.dispatchShowErrorEvent(i18n.unexpected_error() + ': ' + error.message)
            }
            return false
          })
        ) {
          this.updateObjects()
          EventDispatcher.dispatchShowSuccessEvent(i18n.set_taid_deleted())
        }
        this.enable()
      },
      async submit () {
        const taurus = this.isReadyToAdd ? {id: this.form.newID, auto: false} : this.taurusUpdated
        const opts = {
          message: this.isReadyToAdd ? i18n.lbl_id_add_confirm(taurus) : i18n.lbl_autowithdraw_confirm(),
          confirmText: this.isReadyToAdd ? i18n.lbl_add() : ''
        }
        if (!await confirmAction(opts)) return

        this.disable()
        if (await this.updateTaurus(taurus)
          .then(_ => {
            return true
          }).catch(error => {
            console.error(error)
            if (error.showBanner) {
              error.showBanner(i18n.unexpected_error())
            } else {
              EventDispatcher.dispatchShowErrorEvent(i18n.unexpected_error() + ': ' + error.message)
            }
            return false
          })
        ) {
          this.updateObjects(this.isReadyToAdd ? this.userTaurus.length - 1 : this.form.idx)
          EventDispatcher.dispatchShowSuccessEvent(this.isReadyToAdd ? i18n.set_taid_added() : i18n.set_taid_changed())
        }
        this.enable()
      }
    },
    watch: {
      isFormOpened () {
        this.updateObjects()
      },
      'form.newID' (value) {
        this.newTaidUpdated(value)
      },
      'form.idx' (value) {
        if (value === -1) {
          this.newTaidUpdated(this.form.newID)
        } else {
          this.isReadyToAdd = false
          this.form.error = {show: false, message: ''}
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import './settings.scss';

  .md-dialog {
    width: 36rem;
  }
  .auto-withdraw, .delete-taid {
    min-width: 7rem;
    margin-top: 0.2rem;
    margin-bottom: 0;
  }
  .label-select__actions {
    color: $col-text-secondary;
    font-size: 14px;
    margin-bottom: -1rem;
    float: right;
  }
  .label-select__caption {
    margin-left: 1rem;
  }
  .change-taid__item {
    flex-grow: 1;
    align-self: center;
    font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/vue/app/settings/security/Security.Taid.vue